import { render, staticRenderFns } from "./MenuCommonTree.vue?vue&type=template&id=bcbbbf5a"
import script from "./MenuCommonTree.vue?vue&type=script&lang=js"
export * from "./MenuCommonTree.vue?vue&type=script&lang=js"
import style0 from "./MenuCommonTree.vue?vue&type=style&index=0&id=bcbbbf5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports